import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useEffect } from 'react'
import { useIsMounted } from '@dtx-company/true-common/src/hooks/useIsMounted'

export function useProfitWellUserSync({ disabled = false } = {}): void {
  const { isAuthChecked, jwt } = useAuthState()
  const isMounted = useIsMounted()
  useEffect(() => {
    if (disabled) return
    if (isAuthChecked && isMounted() && window?.profitwell && jwt?.email) {
      window.profitwell('user_email', jwt.email)
    }
  }, [disabled, isAuthChecked, isMounted, jwt?.email])
}
